import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../store';
import { FileText, Loader } from 'lucide-react';
import toast from 'react-hot-toast';
import { FIXTURES_ON, vpApi } from '../api/velopulse';

/** 示範資料模式專用：不打後端，直接進稅試算頁供驗收 */
function enterFixturesDemo() {
  const user = { id: 'u-demo', name: '示範使用者', email: 'demo@local', role: 'super_admin', permissions: [] };
  const org = { id: 'org-shengda', name: '盛達汽車貿易', short_name: '盛達汽車', code: 'SD-AUTO', industry: '汽車零售', role: '管理員' };
  localStorage.setItem('token', 'fixture-demo');
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('vp_current_org', JSON.stringify(org));
  window.location.assign('/realty/tax');
}

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('登入成功');
      const inviteToken = sessionStorage.getItem('vp_invite_token');
      if (inviteToken) {
        sessionStorage.removeItem('vp_invite_token');
        navigate(`/invite/${inviteToken}`);
        return;
      }
      try {
        const me = await vpApi.getPlatformMe();
        if (me?.is_platform_admin) {
          toast.success('已偵測平台管理員身分，可從右上角進入「平台管理」', { duration: 4000 });
        }
      } catch { /* 非平台管理員或 API 未就緒 */ }
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || '登入失敗，請確認帳號密碼');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)',
    }}>
      <div style={{ width: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, background: '#1a56db', borderRadius: 16, marginBottom: 12 }}>
            <FileText size={28} color="#fff" />
          </div>
          <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 700 }}>智慧表單平台</h1>
          <p style={{ color: '#94a3b8', fontSize: 14, marginTop: 4 }}>企業客戶資料收集系統</p>
        </div>

        {/* Login Card */}
        <div className="card" style={{ padding: 32 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 24, color: 'var(--text)' }}>登入帳號</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label className="label">電子郵件</label>
              <input className="input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} required placeholder="your@email.com" />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label className="label">密碼</label>
              <input className="input" type="password" value={password}
                onChange={e => setPassword(e.target.value)} required placeholder="••••••••" />
            </div>
            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? <><Loader size={16} style={{ animation: 'spin 1s linear infinite' }} /> 登入中...</> : '登入'}
            </button>
          </form>
          <div style={{ marginTop: 16, textAlign: 'center' }}>
            <Link to="/forgot-password" style={{ color: '#1a56db', fontSize: 13, textDecoration: 'none' }}>忘記密碼？</Link>
          </div>
          {FIXTURES_ON && (
            <button type="button" className="btn btn-lg" style={{ width: '100%', justifyContent: 'center', marginTop: 12 }} onClick={enterFixturesDemo}>
              進入示範（不需後端）
            </button>
          )}

        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
